// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__2FxkC","load6":"Spinner_load6__21Icc","round":"Spinner_round__eva6H"};